<template>
  <div>
    <v-dialog scrollable max-width="400px" v-model="model" persistent>
      <material-card
        :title="
          $t('components.plan_benefit_rules.delete_configuration_dialog.title')
        "
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          <v-form v-model="valid">
            <v-row>
              <v-col xs="12">
                <v-autocomplete
                  multiple
                  :clearable="true"
                  :label="
                    $t(
                      'components.plan_benefit_rules.delete_configuration_dialog.effective_dates'
                    )
                  "
                  v-model="selectedDates"
                  clear-icon="clear"
                  :items="effectiveDates"
                  :rules="[rules.atLeastOne]"
                  :item-text="(item) => formatDate(item.EffectiveDate)"
                  item-value="EffectiveDate"
                  return-object
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="$emit('close')" :loading="loading">
            {{ $t("globals.close") }}
          </v-btn>
          <v-btn
            color="error"
            @click="deleteConfiguration"
            :loading="loading"
          >
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
export default {
  props: ["model", "configuration"],
  components: {
    ErrorHandler,
  },
  data() {
    return {
      valid: false,
      selectedDates: [],
      loading: false,
      error: null,
      effectiveDates: [],
      rules: {
        atLeastOne: (v) => {
          return (
            this.selectedDates.length > 0 ||
            this.$t("validation.at_least_one_date_should_be_selected")
          );
        },
      },
    };
  },
  watch: {
    model: {
      handler(v) {
        if (v) {
          this.selectedDates = [
            { EffectiveDate: this.configuration.EffectiveDate },
          ];
          this.loadData();
        }
      },
    },
  },
  methods: {
    ...mapActions("claims", [
      "getPlanBenefitsDates",
      "deletePlanBenefitRuleConfigurationByEffectiveDate",
    ]),
    formatDate(dateStr) {
      if (dateStr === null || dateStr === undefined) {
        return;
      }
      // console.log(dateStr);
      const [date, time] = dateStr.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
    async loadData() {
      this.loading = true;
      try {
        this.effectiveDates = (await this.getPlanBenefitsDates({
          planIdentityId: this.configuration.PlanId,
        })).data.value;
        console.log(this.effectiveDates, this.selectedDates)
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async deleteConfiguration() {
      this.loading = true;
      console.log(this.selectedDates);
      try {
        await this.deletePlanBenefitRuleConfigurationByEffectiveDate({
          planIdentityId: this.configuration.PlanId,
          payload: this.selectedDates.map(o=>o.EffectiveDate), //.map(o=>o.EffectiveDate),
        });
        this.$emit("deleted");
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style></style>
